import React, { Component } from 'react';
import moment from 'moment';
import RecentActivity from 'components/modules/user/recent-activity';
import CargomaticCard from 'components/v2/card';
import LabelValue from 'components/ui/tailwind/label-value';
import SessionStore from 'stores/SessionStore';
import EditButton from 'components/v2/buttons/EditButton';
import Container from 'components/v2/container';
import { withTranslation } from 'react-i18next';
import { Avatar } from '../Avatar';

const canChangePassword = (account, agent) => {
  if (account._type !== 'Admin') return true;
  if (account._id === agent._id) return true;
  if (agent.roles.includes('admin')) return true;
  return false;
};

const hasEditPermission = (account, agent) => {
  if (agent.roles.includes('admin') || account._id === agent._id) return true;
  return false;
};
class AdminDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { user, t } = this.props;
    return (
      <Container className="min-w-full py-4">
        <div className="grid grid-cols-12 gap-3">
          <div className="col-span-12 md:col-span-4 lg:col-span-3 xl:col-span-3 2xl:col-span-2">
            <CargomaticCard>
              <div className="bg-white rounded-xl flex items-center border-b border-solid border-grey-light pb-2">
                <div className="shrink-0">
                  <Avatar size="medium" url={null} />
                </div>
                <div className="text-lg lg:text-xl font-medium text-black ml-2">
                  {' '}
                  {`${user.first_name} ${user.last_name}`}
                </div>
              </div>
              <div className="flex justify-between pt-2">
                <LabelValue
                  value={`${user.first_name} ${user.last_name}`}
                  icon="user"
                />
                {hasEditPermission(user, SessionStore.getUser()) && (
                  <EditButton onClick={this.props.onEditProfileClick} />
                )}
              </div>
              <LabelValue value={user.email} icon="envelope" />
              <LabelValue value={user.phone} icon="phone" />
              <LabelValue
                value={`Last seen ${moment(user.last_seen).fromNow()} ago...`}
                icon="question-sign"
              />
              <div className="mt-6 border-t border-solid border-grey-light">
                <button
                  disabled={!canChangePassword(user, SessionStore.getUser())}
                  className="w-full button button-hollow-red"
                  onClick={this.props.onChangePasswordClick}
                >
                  {t('CHANGE_PASSWORD')}
                </button>
              </div>
            </CargomaticCard>
          </div>
          <div className="col-span-12 md:col-span-8 lg:col-span-5 xl:col-span-5 2xl:col-span-5">
            <RecentActivity email={user.email} />
          </div>
        </div>
      </Container>
    );
  }
}

export default withTranslation()(AdminDetails);
